/*
 * Public API Surface of ngx-lib/dialog
 */
export * from './dialog.module';
export * from './dialog.component';
